import React, { useState, useEffect } from "react";
import { useWebData } from "../../Context/webDataContext";
import { Link } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import Pagination from "../../utils/Pagination";

function BlogDynamic() {
  const { getBlogData } = useWebData();
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;
  const [featuredBlog, setFeaturedBlog] = useState(null);

  useEffect(() => {
    // Get blog data from cache or fetch if not available
    const blogData = getBlogData();
    if (blogData && blogData.length > 0) {
      setBlogs(blogData);
      setFeaturedBlog(blogData[Math.floor(Math.random() * blogData.length)]);
    }
  }, [getBlogData]);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  return (
    <>
      <Navbar />
      <section className="px-4 md:px-10 lg:px-20 md:mt-6 p-4 mt-18 md:space-y-8 space-y-4">
        <h1 className="text-center text-2xl md:text-4xl font-bold text-gray-800 manrope">Latest Blogs</h1>

        {/* Featured Blog Section */}
        {featuredBlog && (
          <div className="relative w-full rounded-lg overflow-hidden shadow-lg">
            <img
              src={featuredBlog.blogImage || "https://via.placeholder.com/600x400"}
              alt={featuredBlog.blogHeader}
              className="w-full md:h-96 h-64 object-cover brightness-75"
            />
            <div className="absolute bottom-0 left-0 p-6 w-full bg-gradient-to-t from-black via-transparent to-transparent text-white">
              <h2 className="md:text-2xl text-xl font-semibold">{featuredBlog.blogHeader}</h2>
              <p className="md:text-sm text-xs mt-2">{featuredBlog.paragraph.slice(0, 100)}...</p>
              <Link to={`/blog/${featuredBlog.id}`} className="mt-4 inline-block px-4 py-2 text-white rounded-lg shadow primary-bg">Read More</Link>
            </div>
          </div>
        )}

        {/* Blog Grid Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:py-16">
          {currentBlogs.map((blog) => (
            <div key={blog.id} className="bg-white rounded-lg shadow-lg overflow-hidden transform transition duration-300 hover:scale-105">
              <img
                src={blog.blogImage || "https://via.placeholder.com/600x400"}
                alt={blog.blogHeader}
                className="w-full h-40 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900">{blog.blogHeader}</h3>
                <p className="text-sm text-gray-600 mt-2">{blog.paragraph.slice(0, 80)}...</p>
                <Link
                  to={`/blog/${blog.id}`}
                  className="mt-3 inline-block text-sm font-semibold primary-text hover:text-green-500"
                >
                  Read More
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Component */}
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={(page) => setCurrentPage(page)} />
          <span className="md:mt-4"></span>
      </section>
      <Footer />
    </>
  );
}

export default BlogDynamic;
